import type { JSX } from "preact";
import { TypingIndicator } from "./TypingIndicator";
import { PankAgentIcon } from "./Icons";
import type { PankAgentVariant } from "./Icons";
import { MarkdownRenderer } from "./MarkdownRenderer";

export interface ChatMessageProps {
  role: "user" | "assistant";
  content: string;
  isStreaming?: boolean;
  index?: number;
  isNew?: boolean;
  variant?: PankAgentVariant;
}

/**
 * Single chat message bubble
 * User messages: right-aligned purple bubbles with speech bubble tail
 * Assistant messages: left-aligned with avatar and frosted glass effect
 */
export const ChatMessage = ({
  role,
  content,
  isStreaming,
  index = 0,
  isNew = false,
  variant = "default",
}: ChatMessageProps): JSX.Element => {
  const animationStyle = `--msg-index: ${index}`;
  const newMessageClass = isNew ? " new-message" : "";

  if (role === "user") {
    return (
      <div
        class={`pankagent-message user${newMessageClass}`}
        style={animationStyle}
      >
        {content}
      </div>
    );
  }

  // Assistant message with avatar
  return (
    <div
      class={`pankagent-message assistant${newMessageClass}`}
      style={animationStyle}
    >
      <div class="pankagent-message-avatar">
        <PankAgentIcon size={56} variant={variant} />
      </div>
      <div class="pankagent-message-content">
        {content ? (
          <MarkdownRenderer content={content} variant={variant} />
        ) : (
          isStreaming && <TypingIndicator />
        )}
      </div>
    </div>
  );
};
